import { Button, Card, Grid, Typography, message } from 'antd';
import { CopyOutlined, GiftOutlined } from '@ant-design/icons';
import { ReferralLinkData } from '../../types/engagement.types';

const { Text } = Typography;
const { useBreakpoint } = Grid;

interface EngagementReferralHighlightProps {
  referralLink: ReferralLinkData;
}

export const EngagementReferralHighlight = ({ referralLink }: EngagementReferralHighlightProps) => {
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const copyLink = async () => {
    await navigator.clipboard.writeText(referralLink.url);
    message.success('Link de indicação copiado!');
  };

  return (
    <Card
      style={{ marginBottom: 24, background: '#F5F4FF', borderColor: '#2E2B81' }}
      styles={{ body: { padding: isMobile ? 16 : '16px 24px' } }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: isMobile ? 'stretch' : 'center',
          gap: 12,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
          <GiftOutlined style={{ color: '#2E2B81', fontSize: 20 }} />
          <Text strong style={{ color: '#2E2B81', whiteSpace: 'nowrap' }}>
            Convide e ganhe pontos
          </Text>
        </div>

        <Text type="secondary" style={{ flex: 1 }}>
          Copie o link com o botão ao lado e compartilhe nos grupos de WhatsApp e redes sociais. Cada novo
          usuário cadastrado com seu link de indicação gera pontos para você no programa de engajamento.
        </Text>

        <Button type="primary" icon={<CopyOutlined />} onClick={copyLink} block={isMobile}>
          Copiar link de indicação
        </Button>
      </div>
    </Card>
  );
};

export default EngagementReferralHighlight;
